import { useQuery } from "react-query";
import { getSettings } from "services/settings.service";

export default function useSettings() {
  return useQuery("settings", async () => await getSettings(), {
    retry: false,
  });
}
